import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addAptosExtension } from '../addAptosExtension';
export type { AptosNetworkProvider } from '../AptosNetworkProvider.types';
export type { AptosWalletAccount } from '../AptosWalletAccount.types';
export type {
  AptosClient,
  AptosSignTransactionOutput,
  AptosTransaction,
  AptosTransactionPayload,
} from '../AptosWalletProvider.types';
export { NotAptosProviderError } from '../errors/NotAptosProviderError';
export { getAptosClient } from '../getAptosClient';
export { isAptosNetworkProvider } from '../isAptosNetworkProvider';
export { isAptosWalletAccount } from '../isAptosWalletAccount';
export { isAptosWalletProvider } from '../isAptosWalletProvider';
export { signAndSubmitTransaction } from '../signAndSubmitTransaction';
export { signTransaction } from '../signTransaction';
